import HeaderSearch from './header-search';

const headerSearchConfig = {
  name: 'headerSearch',
  class: HeaderSearch,
  querySelector: {
    close: '.header-search-close',
    dialog: '.site-header-search',
    searchInput: '#site-search-input',
  },
  querySelectorAll: {
    focusableElements: 'button, a',
    focusTraps: '.focus-trap',
  },
};

export default headerSearchConfig;
